import React from 'react';
import { useAuth } from '../context/AuthProvider';
import { Navigate, useLocation } from 'react-router-dom';

export function SuperadminRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>; // Or a loading spinner
  }

  // First, check if a user is logged in at all.
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Next, check if the logged-in user has the 'superadmin' role.
  if (user.role !== 'superadmin') {
    // If not a superadmin, send them to the regular agent dashboard
    // or show a "Forbidden" page. Redirecting is often better.
    return <Navigate to="/dashboard" replace />;
  }

  // If all checks pass, render the superadmin page.
  return children;
}